
import React from 'react';

const Header = () => {
    return (
        <nav className="navbar navbar-expand-sm   navbar-light bg-light">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
          <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
            <li className="nav-item">
              <a className="nav-link" href="/">Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item dropdown dmenu">
              <a className="nav-link dropdown-toggle"  id="navbardrop" data-toggle="dropdown">
                Projects
              </a>
              <div className="dropdown-menu sm-menu">
                <a className="dropdown-item" href="/calculator">Calculator App</a>
                <a className="dropdown-item" href="/covid">Covid-19 App</a>
                <a className="dropdown-item" href="/todo">Reminder App</a>
                <a className="dropdown-item" href="/grade">Grade Average App</a>
                <a className="dropdown-item" href="/news">News App</a>
                <a className="dropdown-item" href="/urgentcare">Hialeah Urgent Care</a>

              </div>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="mailto:mail@kennashka.com">Contact</a>
            </li>
          </ul>
          {/* <div className="social-part">
            <a className="nav-link" href="https://github.com/kennashka/grade-average-calculation"><i className="fa fa-github" aria-hidden="true" /> </a>
          </div>
          <div>
            <a className="nav-link" href="https://twitter.com/kennashka"><i className="fa fa-twitter" aria-hidden="false" /></a>
          </div> */}
        </div>
      </nav>

    )
        };

 export default Header;
